import serviceRequest from "utils/request";

const baseUrl = "/application";
let purposeGetallRequest = null;

export const getApplicationList = (param) => {
	return serviceRequest({
		url: `${baseUrl}/get-by-user-profile-id?userProfileId=${param.userProfileId}`,
		method: "get",
	});
};

export const getUserApplicationList = (param) => {
	return serviceRequest({
		url: `${baseUrl}/get-unapproved-by-user-profile-id?userProfileId=${param.userProfileId}`,
		method: "get",
	});
};

export const addApplication = (param) => {
	return serviceRequest({
		url: `${baseUrl}/add`,
		method: "post",
		data: param,
	});
};

export const saveApplication = (param) => {
	return serviceRequest({
		url: `${baseUrl}/edit`,
		method: "post",
		data: param,
	});
};

// export const submitApplication = (param) => {
// 	return serviceRequest({
// 		url: `${baseUrl}/submit?applicationId=${param.applicationId}`,
// 		method: "get",
// 	});
// };

export const submitApplication = (param) => {
	return serviceRequest({
		url: `${baseUrl}/submit/v2`,
		method: "post",
		data: param,
	});
};

export const approveApplication = (param) => {
	return serviceRequest({
		url: `${baseUrl}/approve`,
		method: "post",
		data: param,
	});
};

export const approveEXPERTApplication = (param) => {
	return serviceRequest({
		url: `${baseUrl}/expert/approve`,
		method: "post",
		data: param,
	});
};

export const getApplicationListByConditions = (param) => {
	return serviceRequest({
		url: `${baseUrl}/list-by-conditions`,
		method: "post",
		data: param,
	});
};

export const getApplicationDetail = (param) => {
	return serviceRequest({
		url: `${baseUrl}/application-detail?applicationId=${param.applicationId}`,
		method: "get",
	});
};

export const viewProgressApplication = (param) => {
	return serviceRequest({
		url: `${baseUrl}/v2/view-progress`,
		method: "post",
		data: param,
	});
};

export const withdrawApplication = (param) => {
	return serviceRequest({
		url: `${baseUrl}/withdraw`,
		method: "post",
		data: param,
	});
};

export const getPurposeGetall = () => {
	if (purposeGetallRequest) {
		return purposeGetallRequest;
	}
	purposeGetallRequest = serviceRequest({
		url: `${baseUrl}/purpose/getall`,
		method: "post",
	}).catch((error) => {
		purposeGetallRequest = null;
		throw error;
	});
	return purposeGetallRequest;
};

export const addEXPERT = (param) => {
	return serviceRequest({
		url: `${baseUrl}/expert/add`,
		method: "post",
		data: param,
	});
};
export const submitEXPERT = (param) => {
	return serviceRequest({
		url: `${baseUrl}/expert/submit`,
		method: "post",
		data: param,
	});
};
export const editEXPERT = (param) => {
	return serviceRequest({
		url: `${baseUrl}/expert/edit`,
		method: "post",
		data: param,
	});
};

export const getEXPERTDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/expert/detail`,
		method: "get",
		params,
	});
};

export const getEnableApplicationCreateFlag = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-enable-application-create-flag`,
		method: "get",
		params,
	});
};

export const getServicesData = (params) => {
	return serviceRequest({
		url: `${baseUrl}/researcher-data-service-board`,
		method: "get",
		params,
	});
};

export const updateIdentityVerification = (param) => {
	return serviceRequest({
		url: `${baseUrl}/update-identity-verification`,
		method: "post",
		data: param,
	});
};
